// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./plugins/slicer_cli_web/web_client/stylesheets/panel.styl
// module id = 53
// module chunks = 0